import React from 'react';
import { InView } from 'react-intersection-observer';
import { ImpressionElement, TrackingLocation, impression } from 'tracking';

import useEventTracking from '@hooks/useEventTracking';

import { FooterProps } from '.';
import FormAndSocial from './FormAndSocial';
import Links from './Links';

const FooterContent = ({
  analytics,
  currentUserLoggedin,
  isContentPage,
  isPro,
  isSubscriber,
  leadDetails,
  subscribePathWithPossibleOffer,
}: FooterProps) => {
  const { Track, trackEvent } = useEventTracking({
    ...analytics,
    location: TrackingLocation.Footer,
  });

  return (
    <Track>
      <InView
        triggerOnce={true}
        onChange={(inView) => {
          inView && trackEvent(impression({ impressionElement: ImpressionElement.Footer }));
        }}
      >
        <footer
          className="w-full bg-grayscale-charcoal px-16 py-64 sm:px-28 sm:py-80 dark:bg-[var(--light-grayscale-charcoal)] print:hidden"
          id="ti-footer"
        >
          <div className="m-auto flex max-w-container-lg flex-wrap justify-between">
            <Links />
            <FormAndSocial
              currentUserLoggedin={currentUserLoggedin}
              isContentPage={isContentPage}
              isPro={isPro}
              isSubscriber={isSubscriber}
              leadDetails={leadDetails}
              subscribePathWithPossibleOffer={subscribePathWithPossibleOffer}
            />
          </div>
        </footer>
      </InView>
    </Track>
  );
};

export default FooterContent;
